module.exports = __webpack_public_path__ + "static/img/76-1.948b6f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/76-1.jpg
// module id = QEm8
// module chunks = 0